import { ACTION_TYPES } from '~/core/constants'

const { ROOM_SETTINGS } = ACTION_TYPES

const initialState = {
  userIdentity: {},
  enableUndocked: true,
  isMeetingPreviewEnabled: true,
  access: {},
  recordings: {},
  moderation: {},
  security: {}
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ROOM_SETTINGS.SET_MEETING_PREVIEW_ENABLED: {
      return {
        ...state,
        isMeetingPreviewEnabled: action.payload
      }
    }
    case ROOM_SETTINGS.SET_UNDOCKED: {
      return {
        ...state,
        enableUndocked: action.payload
      }
    }
    case ROOM_SETTINGS.SET_USER_IDENTITY: {
      return {
        ...state,
        userIdentity: action.payload
      }
    }
    case ROOM_SETTINGS.SET_INTENDED_PRESET: {
      const { intendedPreset } = action.payload
      return {
        ...state,
        intendedPreset
      }
    }
    case ROOM_SETTINGS.SET_RECORDING_SETTINGS: {
      return {
        ...state,
        recordings: {
          ...state.recordings,
          ...action.payload
        }
      }
    }
    case ROOM_SETTINGS.SET_MODERATION_SETTINGS: {
      const {
        moderationType,
        activeParticipantUsers,
        joinMuted,
        joinHidden,
        abilityToUnmute,
        visitorPromotionType
      } = action.payload

      return {
        ...state,
        moderation: {
          ...(activeParticipantUsers !== undefined && {
            activeParticipantUsers: [...activeParticipantUsers].sort((a, b) => {
              const myId = state.userIdentity?.id
              return a.userId === myId ? -1 : b.userId === myId ? 1 : 0
            })
          }),
          ...(moderationType !== undefined && { moderationType }),
          ...(joinMuted !== undefined && { joinMuted }),
          ...(joinHidden !== undefined && { joinHidden }),
          ...(abilityToUnmute !== undefined && { abilityToUnmute }),
          ...(visitorPromotionType !== undefined && { visitorPromotionType })
        }
      }
    }
    case ROOM_SETTINGS.SET_SECURITY_SETTINGS: {
      const { passcode, goLiveEnabled, waitForApproval, waitForModerator } = action.payload
      return {
        ...state,
        security: {
          ...state.security,
          ...(passcode !== undefined && { passcode }),
          ...(goLiveEnabled !== undefined && { goLiveEnabled }),
          ...(waitForApproval !== undefined && { waitForApproval }),
          ...(waitForModerator !== undefined && { waitForModerator })
        }
      }
    }
    case ROOM_SETTINGS.SET_ACCESS_SETTINGS: {
      const { allowUnauthenticatedAccess, dialinEnabled } = action.payload
      return {
        ...state,
        access: {
          ...state.access,
          allowUnauthenticatedAccess,
          dialinEnabled
        }
      }
    }
    case ROOM_SETTINGS.SET_OVERRIDE_PERMISSIONS: {
      return {
        ...state,
        overridePermissions: action.payload
      }
    }
    default:
      return state
  }
}

export default reducer
